import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {isBrowser} from "react-device-detect";
import {
    closePharmacyOrderRejectModal
} from "../../../../redux/actions/modals";
import LargeModal from "../../../../components/modals/LargeModal";
import CustomButton from "../../../../components/CustomButton";
import {rejectPharmacyOrder} from "../../../../redux/actions/orders";

const PharmacyOrderRejectComponent = (props) => {
    const dispatch = useDispatch();
    const [items, setItems] = useState([]);
    const [rejectData, setRejectData] = useState({
        reason: 'PRESCRIPTION_CORRUPTED',
        more_description: ''
    });
    const {
        pharmacy_order_reject_open,
        pharmacy_order_reject_order,
    } = useSelector((state) => state.modals);
    const {
        pharmacy_order_cancel_reasons_success,
    } = useSelector((state) => state.orders);
    const {
        reject_pharmacy_order_waiting,
    } = useSelector((state) => state.orders);
    useEffect(() => {
        if (pharmacy_order_cancel_reasons_success.result !== undefined && pharmacy_order_cancel_reasons_success.result === 'SUCCESS') {
            setItems(pharmacy_order_cancel_reasons_success.data.reasons);
        }
    }, [pharmacy_order_cancel_reasons_success]);
    const orderReject = () => {
        const data = {...rejectData, id: pharmacy_order_reject_order.id};
        dispatch(rejectPharmacyOrder(data));
    }
    return (
        <>
            <LargeModal
                header=""
                show={pharmacy_order_reject_open}
                closeFunction={closePharmacyOrderRejectModal}
            >
                <div>
                    {
                        items.map((item, index) => {
                            return (
                                <div key={index} style={isBrowser ? {
                                    border: '1px dashed gray',
                                    borderRadius: '5px',
                                    marginBottom: '5px',
                                    padding: '3px'
                                } : {
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    border: '1px dashed gray',
                                    borderRadius: '5px',
                                    marginBottom: '5px',
                                    padding: '3px'
                                }}>
                                    <input
                                        type="checkbox"
                                        name={"reject-reason"}
                                        id={"reject-reason-" + item.id}
                                        checked={rejectData.reason === item.reasonKey}
                                        value={item.reasonKey}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if (value === item.reasonKey) {
                                                setRejectData((prevState) => ({
                                                    ...prevState, reason: item.reasonKey
                                                }));
                                            }
                                        }}
                                    />
                                    <label className="col-sm-10 col-form-label" htmlFor={"reject-reason-" + item.id}
                                           style={isBrowser ? {textAlign: 'right'} : {
                                               textAlign: 'right',
                                               fontSize: '12px'
                                           }}>{item.reasonValue}</label>
                                </div>
                            )
                        })
                    }
                    <div style={{marginBottom: '5px', marginTop: '5px'}}>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="توضیحات در صورت نیاز"
                            value={rejectData.more_description}
                            onChange={(e) => {
                                const desc = e.target.value;
                                setRejectData(prevState => ({
                                    ...prevState, more_description: desc
                                }))
                            }}
                        />
                    </div>
                    <div style={{display: 'flex', flexDirection: 'row'}}>
                        <CustomButton
                            className="btn btn-success text-white"
                            action={orderReject}
                            loading={reject_pharmacy_order_waiting}
                            content={"رد سفارش"}
                            type={"success"}
                            textWhite={true}
                            block={true}
                            style={{fontSize:'12px'}}
                        />
                        <button className="btn btn-outline-dark"
                                onClick={() => dispatch(closePharmacyOrderRejectModal())} style={{marginRight: '10px', fontSize:'12px'}}>
                            انصراف
                        </button>
                    </div>
                </div>
            </LargeModal>
        </>
    );
};
export default PharmacyOrderRejectComponent;
